<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          :is-advanced="false"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import AppoimentServices from '@/services/api/appointments.api'
import LocationServices from '@/services/api/location.api'
import TherapyServices from '@/services/api/thrpy.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Total de Referidos Vinculados por Empleado',
      routes: ["Informes", "Total de Referidos Vinculados por Empleado"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          months: [],
          centers: [],
          employees: [],
        },
        filters: {
          academicYear: null,
          month: null,
          center: null,
          sie: null,
          dateTo: null,
          dateFrom: null,
          employee: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        clearable: false,
        options: this.model.search.collections.academicYears,
        onChanged: this.onChangeAcademicYear,
        value: this.model.search.filters.academicYear,
      },
      {
        name: 'month',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Mes',
        placeholder: 'Seleccionar',
        options: this.model.search.collections.months,
        value: this.model.search.filters.month,
        class: 'col-md-3',
        disabled: this.model.search.collections.months.length <= 0,
        onChanged: this.onChangeMonth,
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Centro',
        placeholder: 'Seleccionar',
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        class: 'col-md-3',
        disabled: this.model.search.collections.centers.length <= 0,

      },
      {
          name: 'employee',
          component: 'custom-drop-down',
          placeholder: 'Seleccionar',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Empleado',
          icon: 'fa fa-search orange-icon',
          value: this.model.search.filters.employee,
          options: this.model.search.collections.employees,
          leftIcon: true,
          type: 'text',
          class: 'col-md-3',
          disabled: this.model.search.collections.employees.length <= 0,
        },
       {
          name: 'dateFrom',
          component: 'custom-date-picker',
          label: 'Fecha Desde',
          placeholder: 'Seleccionar Fecha Desde',
          class: 'col-md-3',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
      },
      {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: 'Fecha Hasta',
          placeholder: 'Seleccionar Fecha Hasta',
          class: 'col-md-3',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
      },
      
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async onChangeAcademicYear() {
      this.model.search.filters.month = null;
      this.model.search.filters.center = null;
      this.model.search.filters.employee = null;

      await this.getMonth();
      await this.getCenters();
      await this.getEmployees();
    },
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);
    },
    async onHandlerSearch() {
      
      this.process();
    },
    async getMonth(){
      await AppoimentServices.getAppointmentsFilters({ academicYearId: this.model.search.filters.academicYear?.id})
      .then(res => { 
        this.model.search.collections.months = res.data;
      });
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear?.id,
      })
      .then(res => this.model.search.collections.centers = res.data);
    },
    async getEmployees() {
      await TherapyServices.getAdmissionEmployeesByAcademicYear({
        academicYearId: this.model.search.filters.academicYear?.id,
      })
      .then(res => this.model.search.collections.employees = res.data);
    },
    async process() {
        await ReportServices.getReport('reporttotalreferralslinkedbyemployee', {
          academicYearId: this.model.search.filters.academicYear?.id,
          centerId : this.model.search.filters.center?.id,
          monthNumber: this.model.search.filters.period?.id,
          userId: this.model.search.filters.employee?.id,
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>